module.exports = __webpack_public_path__ + "img/map2.90b9fb17.png";